import { Fancybox } from "@fancyapps/ui/dist/fancybox/fancybox.esm.js";

Fancybox.bind()
